import { useState, useEffect } from 'react'
import MainTitle from '../../components/MainTitle'
import { useParams } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import ClinicNav from '../../components/ClinicNav'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import TuiCalendar from '../../components/TuiCalendar'

const Availability = () => {
  const { id } = useParams()
  const axios = useAxiosPrivate()

  const [clinicData, setClinicData] = useState({ name: '' })
  const { setShowLoader } = useAuth()

  const [currentEvents, setCurrentEvents] = useState([])
  const getClinicById = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/companies/${id}`)
      await setClinicData(response.data.result)
    } catch (error) {}
    setShowLoader(false)
  }

  useEffect(() => {
    getClinicById(id)
  }, [])

  const loadCalendarEvents = async (from, to) => {
    setShowLoader(true)
    try {
      const response = await axios.get(
        `/companies/${id}/availability/${from}/${to}`
      )
  
      const events = response.data.result.map((availability) => {
        const type = availability.block_out_type
  
        return {
          id: availability.id,
          title: type ? type.replace('_', ' ').toUpperCase() : 'Availability',
          start: availability.start_time,
          end: availability.end_time,
          category: 'time',
          color: '#fff',
          raw: availability,
        }
      })
  
      setCurrentEvents(events)
    } catch (error) {
      console.error(error)
    }
    setShowLoader(false)
  }
  

  return (
    <section>
      <MainTitle title={`Clinic: ${clinicData.name}`} backButton />
      <ClinicNav active="availability" clinicId={clinicData.id} />

      {id && (
        <TuiCalendar
          events={currentEvents}
          loadEvents={loadCalendarEvents}
          calendarType="availability"
        />
      )}
    </section>
  )
}

export default Availability
